import ContentPageTemplate from '@/components/ContentPageTemplate';
import { marketingPages } from '@/data/marketingPages';

export default function ResourcesPage() {
  return <ContentPageTemplate page={marketingPages.resources} />;
}
